import { EventListType } from '@diritto/common/event/constants';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { isPC } from 'constants/layout';
import { ZIndex } from 'constants/zIndex';
import { usePathname, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
import { Divider } from 'ui-components/common/Divider';
import { Link } from 'ui-components/common/Link';

const EventTabMenuText = {
  [EventListType.Progress]: '진행 중인 이벤트',
  [EventListType.Finish]: '종료된 이벤트',
};

export const EventTabMenu = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const listType = searchParams?.get('listType');

  const isSelectedMenu = useCallback(
    (key: EventListType) => {
      if (!listType) {
        return key === EventListType.Progress;
      }

      if (key === EventListType.Progress) {
        return listType === EventListType.Progress;
      }
      return listType === EventListType.Finish;
    },
    [listType],
  );

  return (
    <StylesMenuWrapper>
      {Object.keys(EventListType).map(key => (
        <StylesMenu key={key} selected={isSelectedMenu(key as EventListType)} href={`${pathname}?listType=${key}`}>
          {EventTabMenuText[key as EventListType]}
          {isSelectedMenu(key as EventListType) && <StylesMenuSelector color={Color.Primary500} position="bottom" />}
        </StylesMenu>
      ))}
    </StylesMenuWrapper>
  );
};

const StylesMenu = styled(Link)(
  ({ selected }: { selected?: boolean }) => css`
    display: flex;
    position: relative;
    height: 44px;
    align-items: center;
    cursor: pointer;
    color: ${selected ? Color.Primary500 : 'initial'};
    font-weight: ${selected ? FontWeight.Bold : FontWeight.Regular};
    ${Typography.XSmall};

    @media (${isPC}) {
      height: 56px;
    }
  `,
);

const StylesMenuWrapper = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: initial;
  ${StylesMenu} + ${StylesMenu} {
    margin-left: 24px;
  }
`;

const StylesMenuSelector = styled(Divider)`
  height: 2px;
  z-index: ${ZIndex.EventTabMenuSelector};
`;
